module.exports = __webpack_public_path__ + "img/Logo-Grexy-banner.7cde90c2.svg";